import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ToggleSwitch from 'components/form-components/ToggleSwitch';
import ConfirmationModal from 'components/common-components/ConfirmationModal';
import { useTranslation } from 'react-i18next';
import { isCustomPermissionAvailable } from 'config/permissionUtils';

const DataConnectionSwitch = ({ data, column, callback }) => {
  const { t } = useTranslation();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [pendingValue, setPendingValue] = useState(null);

  const handleToggleClick = (name, value) => {
    setPendingValue(value);
    setShowConfirmationModal(true);
  };

  const handleConfirmUpdate = async () => {
    await callback.handleDBConnectionUpdate(data, pendingValue);
    setShowConfirmationModal(false);
    setPendingValue(null);
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
    setPendingValue(null);
  };

  return (
    <>
      <ToggleSwitch
        name={'dbConnection'}
        value={data[column] ?? false}
        handleChange={handleToggleClick}
        disabled={
          !data['dbName']?.trim() ||
          !isCustomPermissionAvailable('system.dashboard_setup.dashboardSetupPermission.formSQL')
        }
      />
      <ConfirmationModal
        show={showConfirmationModal}
        title={t('alert_common_title')}
        message={t(
          pendingValue
            ? 'alert_data_connection_confirmation_on_message'
            : 'alert_data_connection_confirmation_off_message',
        )}
        actionList={[
          {
            color: 'black-1',
            text: t('button_cancel'),
            onClick: handleCancel,
          },
          {
            color: 'red-1',
            text: t('button_update'),
            onClick: handleConfirmUpdate,
          },
        ]}
      />
    </>
  );
};

DataConnectionSwitch.propTypes = {
  callback: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  column: PropTypes.string,
};
export default DataConnectionSwitch;
